
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("absYu", function(module, exports) {
/* SpaceNavigation.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $xQxzY = parcelRequire("xQxzY");


var $2XqLN = parcelRequire("2XqLN");


var $inPa6 = parcelRequire("inPa6");


var $fTvzg = parcelRequire("fTvzg");

function $b9e41fd1eb53db27$var$traceUFOHover(name, timestamp) {
    return (0, $fTvzg.default)(name, 'hover', timestamp);
}
var $b9e41fd1eb53db27$export$2e2bcd8739ae039 = $b9e41fd1eb53db27$var$traceUFOHover;



var $5izcQ = parcelRequire("5izcQ");


var $8Psje = parcelRequire("8Psje");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $7zgzO = parcelRequire("7zgzO");


var $6GD8y = parcelRequire("6GD8y");


var $gnkil = parcelRequire("gnkil");


var $luv00 = parcelRequire("luv00");


var $7sVel = parcelRequire("7sVel");


var $fG32j = parcelRequire("fG32j");


var $hp2SH = parcelRequire("hp2SH");


var $7Sm4c = parcelRequire("7Sm4c");





var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $kVysQ = parcelRequire("kVysQ");


var $4NX9d = parcelRequire("4NX9d");


var $6CEg5 = parcelRequire("6CEg5");


var $lEf66 = parcelRequire("lEf66");


var $b8XTE = parcelRequire("b8XTE");


var $7Ndnw = parcelRequire("7Ndnw");


var $3b6WO = parcelRequire("3b6WO");


var $5ZqQS = parcelRequire("5ZqQS");


var $jlIaF = parcelRequire("jlIaF");


var $lkcsM = parcelRequire("lkcsM");


var $56QzY = parcelRequire("56QzY");


var $gz8ZY = parcelRequire("gz8ZY");


var $efvKr = parcelRequire("efvKr");


var $jFmKR = parcelRequire("jFmKR");


var $de2j9 = parcelRequire("de2j9");


var $9wGTI = parcelRequire("9wGTI");


var $jmjWc = parcelRequire("jmjWc");


const $943638c951fcc5a2$export$a995bb9b45901c46 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ur4pv",
    name: "RtPaidFeatureEducationSpotlightLoadable",
    loader: async ()=>(await (parcelRequire("15oJr"))).RtPaidFeatureEducationSpotlight
});



var $8q3aB = parcelRequire("8q3aB");


var $cpa7E = parcelRequire("cpa7E");


var $AF127 = parcelRequire("AF127");


var $aWrnw = parcelRequire("aWrnw");


var $28oQf = parcelRequire("28oQf");


var $fadJK = parcelRequire("fadJK");

const $bd16611e4da44658$var$SPACE_NAV_ID = 'app-navigation-space-container';
const $bd16611e4da44658$var$MANAGE_USERS = 'manage_users';
const $bd16611e4da44658$var$MANAGE_NONLICENSED_USERS = 'manage_nonlicensed_users';
const $bd16611e4da44658$var$MANAGE_GUEST_USERS = 'manage_guest_users'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bd16611e4da44658$var$SpaceNavigationContainerNav3 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb1osq _4t3i1osq _1e0c1txw _2lx21bp4 _16jlkb7n _i0dl1ris _kqswh2mm _1lfz19el _1isic4v4 _1xr0ns44 _160lc4v4 _7oklidpf _1qw1idpf _y6q3idpf _2rj3idpf _1vkv1ylp _1m011txw _7a9e1bp4 _1604kb7n _12k2vuon _vfkrvuon _1c1ro7ao",
            __cmplp.className
        ])
    });
});
const $bd16611e4da44658$var$spaceNavigationContainerStyles = {
    root: "_kqswh2mm"
}; /**
    * In nav4, we don't need any of the custom styles from the nav3 variant.
    * We need to pass the same props / HTML attributes through though so we can use `componentWithFG` for feature flagging.
    */ 
const $bd16611e4da44658$var$SpaceNavigationContainerNav4 = ({ 'data-testid': testId, 'data-vc': dataVc, 'data-ssr-placeholder-replace': dataSSRPlaceholderReplace, onMouseEnter: onMouseEnter, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": testId,
        "data-vc": dataVc,
        "data-ssr-placeholder-replace": dataSSRPlaceholderReplace,
        onMouseEnter: onMouseEnter,
        className: (0, $gMc0m.default)([
            $bd16611e4da44658$var$spaceNavigationContainerStyles.root
        ])
    }, children);
const $bd16611e4da44658$var$createResult = (0, $2XqLN.default)((loading, data, error)=>{
    const result = {
        loading: loading,
        hasSpace: false,
        isSpaceAdmin: false,
        canManageSomeUsers: false,
        containsExternalCollaborators: false,
        main: [],
        quick: [],
        isUserExternalCollaborator: false,
        hasRestrictedError: false,
        hasNotFoundError: false,
        isSpaceArchived: false,
        hasDeleteSpacePermission: false
    };
    if (loading) return result;
    if (error) {
        if ((0, $fG32j.isSpaceRestrictedError)(error)) result.hasRestrictedError = true;
        else if ((0, $fG32j.isSpaceNotFoundError)(error)) result.hasNotFoundError = true;
        else result.unhandledError = error;
        return result;
    }
    result.hasSpace = Boolean(data?.space ?? result.hasSpace);
    result.space = data?.space || undefined;
    result.name = data?.space?.name || undefined;
    result.iconPath = `${0, $jlIaF.CONTEXT_PATH}${data?.space?.icon?.path}`;
    result.isSpaceAdmin = data?.space?.currentUser?.isAdmin ?? result.isSpaceAdmin;
    result.canManageSomeUsers = data?.space?.operations?.some((operation)=>operation?.operation === $bd16611e4da44658$var$MANAGE_USERS || operation?.operation === $bd16611e4da44658$var$MANAGE_NONLICENSED_USERS || operation?.operation === $bd16611e4da44658$var$MANAGE_GUEST_USERS) ?? result.canManageSomeUsers;
    result.homepageId = data?.space?.homepage?.id || undefined;
    result.containsExternalCollaborators = data?.space?.containsExternalCollaborators ?? result.containsExternalCollaborators;
    result.main = data?.spaceSidebarLinks?.main?.filter($bd16611e4da44658$var$isNonNullable) ?? result.main;
    result.quick = data?.spaceSidebarLinks?.quick?.filter($bd16611e4da44658$var$isNonNullable) ?? result.quick;
    result.isUserExternalCollaborator = (0, $lEf66.getUserPermissionFromQuery)(data) === (0, $AF127.SitePermissionType).EXTERNAL;
    result.isSpaceArchived = data?.space?.status === 'archived';
    if (data?.space?.operations) result.hasDeleteSpacePermission = data.space.operations?.some((operation)=>operation?.operation === 'delete' && operation?.targetType === 'space');
    return result;
});
const $bd16611e4da44658$var$usePreloadSpaceNavigation = (spaceKey, isLicensed)=>{
    const { loading: loading, data: data, error: error } = (0, $xQxzY.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $8q3aB.SpaceNavigationQuery), {
        errorPolicy: 'all',
        variables: {
            spaceKey: spaceKey,
            isLicensed: isLicensed
        }
    });
    const result = $bd16611e4da44658$var$createResult(loading, data, error); // dont want the function to run if the FG is off
    // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    if ((0, $9wGTI.fg)('aifc_create_enabled') && (0, $8Psje.isRovoSystemSpaceKey)(spaceKey)) // Rovo system space has temporary content that the user shouldn't interact with outside of Rovo.
    // This space shouldn't be linked to from anywhere in the app, but the user can access it directly via the url.
    result.hasNotFoundError = true;
    if (loading) return result;
    if (error) {
        if ((0, $fG32j.isSpaceRestrictedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        else if ((0, $fG32j.isSpaceNotFoundError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    }
    return result;
};
const $bd16611e4da44658$var$useOldRestrictionsButtonRefetch = ()=>{
    const refetch = (0, $42omo.useCallback)((contentId)=>{
        /**
     * When the PageTree child component informs us that a page has been
     * moved in the hierarchy, we execute a fetch of its new permissions
     * to purge any stale permissions information that the cache may have
     * held for that page. Not doing so would mean showing stale state for
     * its padlock icon, and for its restriction dialog, when raised.
     */ // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        (0, $hp2SH.getApolloClient)().query({
            query: (0, $7sVel.RestrictionsDialogQuery),
            variables: {
                contentId: contentId
            },
            fetchPolicy: 'network-only'
        });
    }, []);
    return refetch;
};
const $bd16611e4da44658$export$a91923d0186f609a = /*#__PURE__*/ (0, $42omo.memo)(({ isBlogNavigation: isBlogNavigation, isSpaceSettingsScreen: isSpaceSettingsScreen = false })=>{
    const [pageTreeFinishedLoading, setPageTreeFinishedLoading] = (0, $42omo.useState)(false);
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const [stateSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)(); // @ts-ignore FIXME: `stateSpaceKey` can be `undefined` here, and needs proper handling
    const spaceKey = stateSpaceKey;
    const { push: push, match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext)); // On a successful move, tell the restrictions button icon that it may need
    // to be updated
    const onDragDropSuccess = $bd16611e4da44658$var$useOldRestrictionsButtonRefetch();
    const onOverviewShortcutTrigger = (0, $42omo.useCallback)(()=>{
        push(`/wiki/spaces/${spaceKey}/overview`);
    }, [
        push,
        spaceKey
    ]);
    const handleMouseEnter = ()=>{
        (0, $b9e41fd1eb53db27$export$2e2bcd8739ae039)('space-navigation-hover');
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'entered',
                actionSubject: 'spaceNavigation',
                source: match?.name,
                attributes: {
                    navdexPointType: (0, $56QzY.START_TOUCH)
                }
            }
        }).fire();
    };
    const { loading: loading, hasRestrictedError: hasRestrictedError, hasNotFoundError: hasNotFoundError, unhandledError: unhandledError, hasSpace: hasSpace, name: name, space: space, iconPath: iconPath, isSpaceAdmin: isSpaceAdmin, canManageSomeUsers: canManageSomeUsers, homepageId: homepageId, containsExternalCollaborators: containsExternalCollaborators, main: main, quick: quick, isUserExternalCollaborator: isUserExternalCollaborator, isSpaceArchived: isSpaceArchived, hasDeleteSpacePermission: hasDeleteSpacePermission } = $bd16611e4da44658$var$usePreloadSpaceNavigation(spaceKey, isLicensed);
    const { loading: loadingForgeApps, extensions: forgeApps, error: forgeError } = (0, $3b6WO.useExtensionList)({
        moduleType: (0, $7Ndnw.FORGE_MODULE_SPACE_PAGE),
        spaceContextOnly: true
    });
    if (forgeError && !(0, $7Sm4c.isErrorMarkedAsHandled)(forgeError)) {
        (0, $5ZqQS.getMonitoringClient)().submitError(forgeError, {
            attribution: (0, $3IBnw.Attribution).ECOSYSTEM
        });
        (0, $7Sm4c.markErrorAsHandled)(forgeError);
    }
    const { allAppLinks: allAppLinks, allVisibleAppLinks: allVisibleAppLinks, shouldRenderSpaceApps: shouldRenderSpaceApps } = (0, $cpa7E.getAllAppLinks)(spaceKey, main, forgeApps, isSpaceAdmin);
    const shortcutsHidden = main.filter(({ webItemCompleteKey: webItemCompleteKey, hidden: hidden })=>webItemCompleteKey === (0, $28oQf.SHORTCUTS_KEY) && hidden).length > 0; // check if blogs should show. Blogs are default off if the webitem does not exist.
    const blogsWebItem = main.find(({ webItemCompleteKey: webItemCompleteKey })=>webItemCompleteKey === (0, $28oQf.BLOG_KEY));
    const blogsHidden = !blogsWebItem || blogsWebItem.hidden === true;
    const showShortcutsSection = !loading && !shortcutsHidden;
    const onContentTreeLoadComplete = (0, $42omo.useCallback)(()=>{
        setPageTreeFinishedLoading(true);
    }, []);
    const hasSideNavError = Boolean(unhandledError || hasRestrictedError || hasNotFoundError);
    const { isUserViewingSpaceAsAnon: isUserViewingSpaceAsAnon, loading: anonymousAccessQueryLoading, error: anonymousAccessQueryError } = (0, $jFmKR.useIsUserViewingSpaceAsAnon)({
        spaceKey: spaceKey,
        skipQuery: isNav4Enabled || hasSideNavError
    });
    const spaceId = space?.id || '';
    const spaceName = name || '';
    const isStarred = Boolean(space?.currentUser?.isFavourited);
    const isWatched = Boolean(space?.currentUser?.isWatched);
    const spaceOverviewShortcut = isNav4Enabled ? (0, $gnkil.SPACE_OVERVIEW_SHORTCUT) : (0, $gnkil.SPACE_OVERVIEW_SHORTCUT_NAV_3);
    const SpaceNavigationContainer = isNav4Enabled ? $bd16611e4da44658$var$SpaceNavigationContainerNav4 : $bd16611e4da44658$var$SpaceNavigationContainerNav3;
    const navigationProps = {
        loading: loading,
        hasSpace: hasSpace,
        space: space,
        spaceKey: spaceKey,
        homepageId: homepageId,
        main: main,
        quick: quick,
        isSpaceAdmin: isSpaceAdmin,
        canManageSomeUsers: canManageSomeUsers,
        isBlogNavigation: isBlogNavigation,
        blogsHidden: blogsHidden,
        pageTreeFinishedLoading: pageTreeFinishedLoading,
        onDragDropSuccess: onDragDropSuccess,
        showShortcutsSection: showShortcutsSection,
        shouldRenderSpaceApps: shouldRenderSpaceApps,
        allAppLinks: allAppLinks,
        allVisibleAppLinks: allVisibleAppLinks,
        loadingForgeApps: loadingForgeApps,
        anonymousAccessQueryLoading: anonymousAccessQueryLoading,
        onContentTreeLoadComplete: onContentTreeLoadComplete
    };
    const errorProps = {
        unhandledError: unhandledError,
        hasRestrictedError: hasRestrictedError,
        hasNotFoundError: hasNotFoundError,
        anonymousAccessQueryError: anonymousAccessQueryError
    };
    const spaceDetails = {
        spaceId: spaceId,
        spaceName: spaceName,
        spaceKey: spaceKey,
        homepageId: homepageId,
        iconPath: iconPath,
        isStarred: isStarred,
        isWatched: isWatched,
        isSpaceAdmin: isSpaceAdmin,
        canManageSomeUsers: canManageSomeUsers,
        isPersonalSpace: space?.type === 'personal',
        containsExternalCollaborators: containsExternalCollaborators,
        isUserExternalCollaborator: isUserExternalCollaborator,
        isSpaceArchived: isSpaceArchived,
        hasDeleteSpacePermission: hasDeleteSpacePermission
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: "enhance-orientation-spotlight-tour-target-1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(SpaceNavigationContainer, {
        "data-testid": $bd16611e4da44658$var$SPACE_NAV_ID,
        "data-vc": "space-navigation",
        onMouseEnter: handleMouseEnter,
        ...ssrPlaceholderIdProp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6CEg5.PerformanceStart), {
        subject: (0, $kVysQ.PERFORMANCE_SUBJECT_navigation),
        subjectId: "SpaceViewLoading"
    }), isNav4Enabled ? !loading && hasSpace && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fadJK.SpaceNavigationContent), {
        navigationProps: navigationProps,
        errorProps: errorProps,
        spaceDetails: spaceDetails
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fadJK.Nav3SpaceNavigationContent), {
        navigationProps: navigationProps,
        errorProps: errorProps,
        name: name,
        iconPath: iconPath,
        containsExternalCollaborators: containsExternalCollaborators,
        isUserExternalCollaborator: isUserExternalCollaborator,
        isSpaceSettingsScreen: isSpaceSettingsScreen,
        isUserViewingSpaceAsAnon: isUserViewingSpaceAsAnon
    }), isNav4Enabled && pageTreeFinishedLoading && (0, $9wGTI.fg)('rt_paid_feature_education_ab_fg') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $943638c951fcc5a2$export$a995bb9b45901c46), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        key: "overview-shortcut",
        deprecatedAccelerator: !(isLiveEditMode || isOnEditRoute) ? spaceOverviewShortcut : undefined,
        accelerator: (0, $gnkil.UNIVERSAL_SPACE_OVERVIEW_SHORTCUT),
        listener: onOverviewShortcutTrigger
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4NX9d.PerformanceEnd), {
        subject: (0, $kVysQ.PERFORMANCE_SUBJECT_sideNavigationFMP),
        subjectId: "SideNavigationFMP",
        includeFeatureFlags: true
    }), !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b8XTE.PageSegmentLoadEnd), {
        key: spaceKey,
        metric: (0, $aWrnw.SPACE_NAVIGATION_METRIC)
    }), unhandledError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: unhandledError
    }), (0, window.__SSR_RENDERED__) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lkcsM.FocusToCurrentPageTreeLinkItemSSRInlineScript), null))));
});
function $bd16611e4da44658$var$isNonNullable(x) {
    return Boolean(x);
}
module.exports["SpaceNavigation"] = $bd16611e4da44658$export$a91923d0186f609a;

});

parcelRegister("5izcQ", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $QiYCb = parcelRequire("QiYCb");


var $6cnUO = parcelRequire("6cnUO");

/**
 * __Spotlight target__
 *
 * A spotlight target marks a component to be used for introducing new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 *
 * @deprecated Use `@atlaskit/spotlight` instead.
 */ const $f788f1551fff696f$var$SpotlightTarget = ({ children: children, name: name })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6cnUO.TargetConsumer), {
        children: (getTargetRef)=>{
            if (typeof children === 'function') return children({
                targetRef: getTargetRef?.(name)
            });
            return getTargetRef ? /*#__PURE__*/ (0, $l998X.jsx)((0, $QiYCb.default), {
                name: name,
                hasNodeResolver: !(0, $dh538.fg)('platform_design_system_team_onboarding_noderesolve'),
                getTargetRef: getTargetRef,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                    children: children
                })
            }) : children;
        }
    });
$f788f1551fff696f$var$SpotlightTarget.displayName = 'SpotlightTarget';
var $f788f1551fff696f$export$2e2bcd8739ae039 = $f788f1551fff696f$var$SpotlightTarget;
module.exports["default"] = $f788f1551fff696f$export$2e2bcd8739ae039;

});

parcelRegister("QiYCb", function(module, exports) {
/* node-resolver-spotlight-target.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $e8Hkv = parcelRequire("e8Hkv");

const $9a3edd35791f2369$var$spanStyles = null; /**
                          * A wrapper component that conditionally applies a NodeResolver to its children.
                          *
                          * Note: NodeResolver should not be used in React 18 concurrent mode. This component
                          * is intended to be removed once the feature flag  is removed.
                          * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
                          * @param {ReactElement} props.children - The child elements to be wrapped.
                          * @param {string} props.name - The name to reference from Spotlight.
                          * @param {ReactElement} props.getTargetRef - Setting up Target Node in Spotlight Manager.
                          * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, wrape the children in a div setting innerRef with ref to the div.
                          */ 
const $9a3edd35791f2369$var$NodeResolverSpotlightTarget = ({ hasNodeResolver: hasNodeResolver, children: children, getTargetRef: getTargetRef, name: name })=>{
    const divRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        const targetRef = getTargetRef(name);
        if (!hasNodeResolver) targetRef(divRef.current?.firstElementChild);
        return ()=>{
            !hasNodeResolver && targetRef(undefined);
        };
    }, [
        hasNodeResolver,
        name,
        getTargetRef
    ]);
    if (hasNodeResolver) return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e8Hkv))), {
        innerRef: getTargetRef(name),
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        ref: divRef,
        className: (0, $gMc0m.default)([
            "_1e0c1bgi"
        ]),
        children: children
    });
};
$9a3edd35791f2369$var$NodeResolverSpotlightTarget.displayName = 'NodeResolverSpotlightTarget';
var $9a3edd35791f2369$export$2e2bcd8739ae039 = $9a3edd35791f2369$var$NodeResolverSpotlightTarget;
module.exports["default"] = $9a3edd35791f2369$export$2e2bcd8739ae039;

});

parcelRegister("8Psje", function(module, exports) {
const $5c0c9a15440579bc$export$fb74cd09fc20f0c3 = (spaceKey)=>{
    if (!spaceKey) return false;
    return spaceKey.startsWith('~ROVO') && spaceKey.endsWith('~');
};
module.exports["isRovoSystemSpaceKey"] = $5c0c9a15440579bc$export$fb74cd09fc20f0c3;

});

parcelRegister("6GD8y", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $2944f0e1873f71ce$export$90839ff33b4905a0 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "pU1rv",
    name: "GeneralShortcutListener",
    loader: async ()=>(await (parcelRequire("9Q4ck"))).GeneralShortcutListener
});
module.exports["GeneralShortcutListener"] = $2944f0e1873f71ce$export$90839ff33b4905a0;

});

parcelRegister("9Q4ck", function(module, exports) {

let $729c39fbd06cc51d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $729c39fbd06cc51d$var$load("fZt2F"),
    $729c39fbd06cc51d$var$load("hhss7"),
    $729c39fbd06cc51d$var$load("kpHRm")
]).then(()=>parcelRequire('3w3bV'));

});

parcelRegister("gnkil", function(module, exports) {
// Note: When modifying shortcut settings, make sure to test across all input fields on the page.
// Some input fields may not have shortcuts fully disabled, which could cause conflicts with shortcuts.
// Ensure that the new shortcuts do not interfere with normal input field operations.
// When making change in this file, make sure the corresponding tab in @confluence/keyboard-shortcuts-dialog is also updated
// Shortcuts for editor2
const $e13bb5c64c0a0eec$export$170fefa3f8a9258a = {
    PUBLISH: 'mod+enter',
    PUBLISH_WITH_COMMENT: 'mod+shift+enter',
    EDIT: 'e',
    PREVIEW: 'mod+shift+e',
    UNDO: 'mod+z',
    REDO: 'mod+shift+z',
    FIND_REPLACE: 'mod+f'
};
const $e13bb5c64c0a0eec$export$1cbe44c5850db728 = 'mod+s';
const $e13bb5c64c0a0eec$export$73148f05a63f43f = 'command+enter';
const $e13bb5c64c0a0eec$export$67c56ed34ece0f2a = 'mod+enter';
const $e13bb5c64c0a0eec$export$c19d729632cce38f = 'b';
const $e13bb5c64c0a0eec$export$e896f39257754358 = 'c';
const $e13bb5c64c0a0eec$export$c9d367283380f242 = 'f';
const $e13bb5c64c0a0eec$export$44da7c32f8b979f6 = 'm';
const $e13bb5c64c0a0eec$export$f10fe393178b1b45 = 'k';
const $e13bb5c64c0a0eec$export$3837d28de95f38e = 'e';
const $e13bb5c64c0a0eec$export$99088c948bf0270f = 'r';
const $e13bb5c64c0a0eec$export$ddb528ae2130e6f3 = 'w';
const $e13bb5c64c0a0eec$export$95a205588c16f013 = 's';
const $e13bb5c64c0a0eec$export$f7fab4391dadca28 = 'l';
const $e13bb5c64c0a0eec$export$2f62883c954429eb = 't';
const $e13bb5c64c0a0eec$export$96f161bee6b4340d = 'n';
const $e13bb5c64c0a0eec$export$ef9cfcdc2a9ff172 = 'p';
const $e13bb5c64c0a0eec$export$f0bc8e18b9c1c031 = 'g f';
const $e13bb5c64c0a0eec$export$b947af6524920798 = 'g g';
const $e13bb5c64c0a0eec$export$53e346b715d2b7c7 = 'g d';
const $e13bb5c64c0a0eec$export$8cb32cdc75719ad2 = 'g n';
const $e13bb5c64c0a0eec$export$b4842d8ad92c38a3 = 'g r';
const $e13bb5c64c0a0eec$export$298e62593d4ef85 = 'g s';
const $e13bb5c64c0a0eec$export$5d4720de35488ecb = 'g s';
const $e13bb5c64c0a0eec$export$9a4b5405eaaa0bd7 = 'g o';
const $e13bb5c64c0a0eec$export$f5473855a7a167a7 = 'g c';
const $e13bb5c64c0a0eec$export$cee4257b1a828f0d = '/';
const $e13bb5c64c0a0eec$export$159e447a25b21930 = '[';
const $e13bb5c64c0a0eec$export$922297bddc2a63e6 = 'mod+z';
const $e13bb5c64c0a0eec$export$420825475f86fe8d = 'left';
const $e13bb5c64c0a0eec$export$db9252a2db2b8e9e = 'right';
const $e13bb5c64c0a0eec$export$faa4136cec2aa7a0 = '?';
const $e13bb5c64c0a0eec$export$362c0171844ea600 = 'a';
const $e13bb5c64c0a0eec$export$5d80e625aa457659 = ']';
const $e13bb5c64c0a0eec$export$cc9bab4159e8aec9 = 'e';
const $e13bb5c64c0a0eec$export$285e80cf6c078ba6 = 'mod+shift+e';
const $e13bb5c64c0a0eec$export$8d0081a3f70f258c = 'ctrl+.';
const $e13bb5c64c0a0eec$export$d9b4e2a8acc45d14 = 'ctrl+,';
const $e13bb5c64c0a0eec$export$de4065c6a68e4031 = 'mod+option+c';
const $e13bb5c64c0a0eec$export$b5f3b4e8358360b3 = 'ctrl+shift+d';
const $e13bb5c64c0a0eec$export$9cee57908df99565 = 'ctrl+option+n';
const $e13bb5c64c0a0eec$export$b0a212f4fb6d9350 = 'mod+shift+u';
const $e13bb5c64c0a0eec$export$986cc862e5f6eec1 = 'mod+option+r';
const $e13bb5c64c0a0eec$export$d3b6b270c6770b4f = 'ctrl+option+r';
const $e13bb5c64c0a0eec$export$adb85b0fd79d17f8 = 'ctrl+]';
const $e13bb5c64c0a0eec$export$1822b04007c39b0c = 'mod+option+shift+b';
const $e13bb5c64c0a0eec$export$5dd7c1bb4d898f99 = 'ctrl+option+c';
const $e13bb5c64c0a0eec$export$f5ba0af3c65d3125 = 'meta+alt+c';
const $e13bb5c64c0a0eec$export$c372eed375f60e68 = 'ctrl+shift+/';
const $e13bb5c64c0a0eec$export$406fcfa6807667 = 'ctrl+[';
const $e13bb5c64c0a0eec$export$4ec29504bd71f204 = 'ctrl+option+f';
const $e13bb5c64c0a0eec$export$4148526d63a5bc01 = 'mod+option+o';
const $e13bb5c64c0a0eec$export$b7088d9be4883093 = 'ctrl+option+z';
const $e13bb5c64c0a0eec$export$e14ed0c2460e0a5c = 'alt+shift+z';
const $e13bb5c64c0a0eec$export$2bdd2e57d23976c4 = 'mod+option+h';
const $e13bb5c64c0a0eec$export$e3a3f5ea05a3d899 = 'mod+option+g';
const $e13bb5c64c0a0eec$export$18a9bb0de7844bb6 = 'mod+option+8';
const $e13bb5c64c0a0eec$export$3fe2d0f3fe115364 = 'mod+option+v';
const $e13bb5c64c0a0eec$export$a3e38cca130cbc49 = 'mod+option+w';
const $e13bb5c64c0a0eec$export$a769ea2ac46f94da = 'ctrl+option+w';
const $e13bb5c64c0a0eec$export$ddfbfebfa9c821fd = 'mod+option+s';
const $e13bb5c64c0a0eec$export$4bc8c55d04859f5a = 'ctrl+shift+i';
const $e13bb5c64c0a0eec$export$1f53991bf9b208a0 = 'ctrl+option+a';
const $e13bb5c64c0a0eec$export$650d7b87402f841f = 'ctrl+option+t';
const $e13bb5c64c0a0eec$export$dc2c2f2eed832016 = 'meta+alt+t';
const $e13bb5c64c0a0eec$export$1a9b1a10dcf9f02d = 'mod+.';
const $e13bb5c64c0a0eec$export$c252fe6b173dfad3 = 'ctrl+meta+.';
const $e13bb5c64c0a0eec$export$a1552937ff7cca64 = 'mod+option+k';
const $e13bb5c64c0a0eec$export$f7727b957c03a88b = 'ctrl+mod+e';
const $e13bb5c64c0a0eec$export$f0043475aa91a151 = 'alt+meta+x';
module.exports["EDITOR2_SHORTCUTS"] = $e13bb5c64c0a0eec$export$170fefa3f8a9258a;
module.exports["BROWSER_SAVE_SHORTCUT"] = $e13bb5c64c0a0eec$export$1cbe44c5850db728;
module.exports["COMMENT_EDITOR_SHORTCUT"] = $e13bb5c64c0a0eec$export$73148f05a63f43f;
module.exports["INLINE_COMMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$67c56ed34ece0f2a;
module.exports["BLOG_SHORTCUT"] = $e13bb5c64c0a0eec$export$c19d729632cce38f;
module.exports["GLOBAL_CREATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$e896f39257754358;
module.exports["STAR_BUTTON_SHORTCUT"] = $e13bb5c64c0a0eec$export$c9d367283380f242;
module.exports["CREATE_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$44da7c32f8b979f6;
module.exports["LINK_TO_THIS_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$f10fe393178b1b45;
module.exports["EDIT_SHORTCUT"] = $e13bb5c64c0a0eec$export$3837d28de95f38e;
module.exports["PRESENTATION_MODE_SHORTCUT"] = $e13bb5c64c0a0eec$export$99088c948bf0270f;
module.exports["WATCH_CONTENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$ddb528ae2130e6f3;
module.exports["SHARE_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$95a205588c16f013;
module.exports["LABELS_SHORTCUT"] = $e13bb5c64c0a0eec$export$f7fab4391dadca28;
module.exports["VIEW_ATTACHMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$2f62883c954429eb;
module.exports["NEXT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$96f161bee6b4340d;
module.exports["PREV_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$ef9cfcdc2a9ff172;
module.exports["SUBMIT_FEEDBACK_SHORTCUT"] = $e13bb5c64c0a0eec$export$f0bc8e18b9c1c031;
module.exports["NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$b947af6524920798;
module.exports["GO_HOME_SHORTCUT"] = $e13bb5c64c0a0eec$export$53e346b715d2b7c7;
module.exports["NOTIFICATIONS_SHORTCUT"] = $e13bb5c64c0a0eec$export$8cb32cdc75719ad2;
module.exports["GO_TO_RECENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$b4842d8ad92c38a3;
module.exports["GO_TO_STARRED_SHORTCUT"] = $e13bb5c64c0a0eec$export$298e62593d4ef85;
module.exports["SPACE_OVERVIEW_SHORTCUT_NAV_3"] = $e13bb5c64c0a0eec$export$5d4720de35488ecb;
module.exports["SPACE_OVERVIEW_SHORTCUT"] = $e13bb5c64c0a0eec$export$9a4b5405eaaa0bd7;
module.exports["AI_MATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$f5473855a7a167a7;
module.exports["NAVIGATION_SLASH_SHORTCUT"] = $e13bb5c64c0a0eec$export$cee4257b1a828f0d;
module.exports["SIDE_NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$159e447a25b21930;
module.exports["UNDO_SHORTCUT"] = $e13bb5c64c0a0eec$export$922297bddc2a63e6;
module.exports["PREV_TEMPLATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$420825475f86fe8d;
module.exports["NEXT_TEMPLATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$db9252a2db2b8e9e;
module.exports["HELP_SHORTCUT"] = $e13bb5c64c0a0eec$export$faa4136cec2aa7a0;
module.exports["AUTOMATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$362c0171844ea600;
module.exports["TOGGLE_INLINE_COMMENTS_SHORTCUT_RENDERER"] = $e13bb5c64c0a0eec$export$5d80e625aa457659;
module.exports["LIVE_PAGE_MODE_SWITCH_TO_EDIT"] = $e13bb5c64c0a0eec$export$cc9bab4159e8aec9;
module.exports["LIVE_PAGE_MODE_SWITCH_TO_VIEW"] = $e13bb5c64c0a0eec$export$285e80cf6c078ba6;
module.exports["UNIVERSAL_NEXT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$8d0081a3f70f258c;
module.exports["UNIVERSAL_PREV_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$d9b4e2a8acc45d14;
module.exports["UNIVERSAL_OPEN_COMMENT_EDITOR"] = $e13bb5c64c0a0eec$export$de4065c6a68e4031;
module.exports["UNIVERSAL_CREATE_LIVE_DOC_SHORTCUT"] = $e13bb5c64c0a0eec$export$b5f3b4e8358360b3;
module.exports["UNIVERSAL_CREATE_NOTE_SHORTCUT"] = $e13bb5c64c0a0eec$export$9cee57908df99565;
module.exports["UNIVERSAL_NEXT_UNREAD_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$b0a212f4fb6d9350;
module.exports["UNIVERSAL_PRESENTATION_MODE_SHORTCUT"] = $e13bb5c64c0a0eec$export$986cc862e5f6eec1;
module.exports["UNIVERSAL_PRESENTATION_MODE_SHORTCUT_SAFARI"] = $e13bb5c64c0a0eec$export$d3b6b270c6770b4f;
module.exports["UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$adb85b0fd79d17f8;
module.exports["UNIVERSAL_BLOG_SHORTCUT"] = $e13bb5c64c0a0eec$export$1822b04007c39b0c;
module.exports["UNIVERSAL_GLOBAL_CREATE_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$5dd7c1bb4d898f99;
module.exports["UNIVERSAL_GLOBAL_CREATE_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$f5ba0af3c65d3125;
module.exports["UNIVERSAL_HELP_SHORTCUT"] = $e13bb5c64c0a0eec$export$c372eed375f60e68;
module.exports["UNIVERSAL_SIDE_NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$406fcfa6807667;
module.exports["UNIVERSAL_STAR_BUTTON_SHORTCUT"] = $e13bb5c64c0a0eec$export$4ec29504bd71f204;
module.exports["UNIVERSAL_NOTIFICATIONS_SHORTCUT"] = $e13bb5c64c0a0eec$export$4148526d63a5bc01;
module.exports["UNIVERSAL_NAVIGATION_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$b7088d9be4883093;
module.exports["UNIVERSAL_NAVIGATION_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$e14ed0c2460e0a5c;
module.exports["UNIVERSAL_GO_HOME_SHORTCUT"] = $e13bb5c64c0a0eec$export$2bdd2e57d23976c4;
module.exports["UNIVERSAL_GO_TO_RECENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$e3a3f5ea05a3d899;
module.exports["UNIVERSAL_GO_TO_STARRED_SHORTCUT"] = $e13bb5c64c0a0eec$export$18a9bb0de7844bb6;
module.exports["UNIVERSAL_SPACE_OVERVIEW_SHORTCUT"] = $e13bb5c64c0a0eec$export$3fe2d0f3fe115364;
module.exports["UNIVERSAL_WATCH_CONTENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$a3e38cca130cbc49;
module.exports["UNIVERSAL_WATCH_CONTENT_SHORTCUT_SAFARI"] = $e13bb5c64c0a0eec$export$a769ea2ac46f94da;
module.exports["UNIVERSAL_SHARE_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$ddfbfebfa9c821fd;
module.exports["UNIVERSAL_OPEN_DETAILS_PANEL_SHORTCUT"] = $e13bb5c64c0a0eec$export$4bc8c55d04859f5a;
module.exports["UNIVERSAL_LABELS_SHORTCUT"] = $e13bb5c64c0a0eec$export$1f53991bf9b208a0;
module.exports["UNIVERSAL_VIEW_ATTACHMENTS_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$650d7b87402f841f;
module.exports["UNIVERSAL_VIEW_ATTACHMENTS_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$dc2c2f2eed832016;
module.exports["UNIVERSAL_AI_MATE_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$1a9b1a10dcf9f02d;
module.exports["UNIVERSAL_AI_MATE_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$c252fe6b173dfad3;
module.exports["UNIVERSAL_LINK_TO_THIS_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$a1552937ff7cca64;
module.exports["UNIVERSAL_SELECT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$f7727b957c03a88b;
module.exports["UNIVERSAL_OPEN_DEVTOOLS_SHORTCUT"] = $e13bb5c64c0a0eec$export$f0043475aa91a151;

});

parcelRegister("7sVel", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $10293139900c2f2d$export$7ce5458972dd5c90 = (0, $eSUdr.default)`query ReadUserWithRestrictionsQuery($contentId:ID!$status:[String]$draftShareId:String$readUserStart:Int=0){content(id:$contentId status:$status draftShareId:$draftShareId){nodes{id restrictions{read{restrictions{userWithRestrictions(start:$readUserStart){count nodes{type displayName accountId profilePicture{path}hasSpaceViewPermission hasSpaceEditPermission permissionType restrictingContent{id links{webui base}}}pageInfo{hasNextPage endCursor}}}}}}}}`;
const $10293139900c2f2d$export$1f58782141ae545e = (0, $eSUdr.default)`query ReadGroupsQuery($contentId:ID!$status:[String]$draftShareId:String$readGroupStart:Int=0){content(id:$contentId status:$status draftShareId:$draftShareId){nodes{id restrictions{read{restrictions{group(start:$readGroupStart){count nodes{id name permissionType}pageInfo{hasNextPage endCursor}}}}}}}}`;
const $10293139900c2f2d$export$71787d00a8a66c32 = (0, $eSUdr.default)`query EditUserWithRestrictionsQuery($contentId:ID!$status:[String]$draftShareId:String$editUserStart:Int=0){content(id:$contentId status:$status draftShareId:$draftShareId){nodes{id restrictions{update{restrictions{userWithRestrictions(start:$editUserStart){count nodes{type displayName accountId profilePicture{path}hasSpaceViewPermission hasSpaceEditPermission permissionType restrictingContent{id links{webui base}}}pageInfo{hasNextPage endCursor}}}}}}}}`;
const $10293139900c2f2d$export$a78dcd799ff0fd80 = (0, $eSUdr.default)`query EditGroupsQuery($contentId:ID!$status:[String]$draftShareId:String$editGroupStart:Int=0){content(id:$contentId status:$status draftShareId:$draftShareId){nodes{id restrictions{update{restrictions{group(start:$editGroupStart){count nodes{id name permissionType}pageInfo{hasNextPage endCursor}}}}}}}}`;
const $10293139900c2f2d$export$840aea712ef7b5d = (0, $eSUdr.default)`query RestrictionsDialogQuery($contentId:ID!$status:[String]$draftShareId:String$readUserStart:Int=0$readGroupStart:Int=0$editUserStart:Int=0$editGroupStart:Int=0){content(id:$contentId status:$status draftShareId:$draftShareId){nodes{id ancestors{id hasViewRestrictions links{webui}}hasInheritedRestrictions hasRestrictions hasViewRestrictions title type status subType operations{operation targetType}restrictions{read{restrictions{userWithRestrictions(start:$readUserStart){count nodes{type displayName accountId profilePicture{path}hasSpaceViewPermission hasSpaceEditPermission permissionType restrictingContent{id links{webui base}}}pageInfo{hasNextPage endCursor}}group(start:$readGroupStart){count nodes{id name permissionType}pageInfo{hasNextPage endCursor}}}}update{restrictions{userWithRestrictions(start:$editUserStart){count nodes{type displayName accountId profilePicture{path}hasSpaceViewPermission hasSpaceEditPermission permissionType restrictingContent{id links{webui base}}}pageInfo{hasNextPage endCursor}}group(start:$editGroupStart){count nodes{id name permissionType}pageInfo{hasNextPage endCursor}}}}}space{id containsExternalCollaborators externalCollaboratorCount}}}user:confluence_atlassianUser(current:true){id displayName photos{value isPrimary}}tenant:confluence_tenantContext{editions{confluence}}}`;
module.exports["ReadUserWithRestrictionsQuery"] = $10293139900c2f2d$export$7ce5458972dd5c90;
module.exports["ReadGroupsQuery"] = $10293139900c2f2d$export$1f58782141ae545e;
module.exports["EditUserWithRestrictionsQuery"] = $10293139900c2f2d$export$71787d00a8a66c32;
module.exports["EditGroupsQuery"] = $10293139900c2f2d$export$a78dcd799ff0fd80;
module.exports["RestrictionsDialogQuery"] = $10293139900c2f2d$export$840aea712ef7b5d;

});

parcelRegister("fG32j", function(module, exports) {

var $j1Ss3 = parcelRequire("j1Ss3");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $ep3mz = parcelRequire("ep3mz");


var $6jrkJ = parcelRequire("6jrkJ");


var $6mKj3 = parcelRequire("6mKj3");


var $3joiD = parcelRequire("3joiD");


var $6wbAc = parcelRequire("6wbAc");

function $06e8bea7aad8a7b8$export$f1b4255eb8ae314e({ asSuperAdmin: asSuperAdmin, children: children, spaceKey: spaceKey }) {
    const superAdminClaim = (0, $6jrkJ.getSuperAdminClaim)();
    const [stateSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    let data, error, loading;
    if ((0, $6mKj3.expVal)('confluence_restrictions_fix', 'isEnabled', false)) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const result = (0, $j1Ss3.useQuery)(...(0, $3joiD.getQueryParamsAndSetFetchPolicyForNetworkOnlyQuery)({
            query: (0, $6wbAc.SpaceRestrictionCheckQuery),
            context: asSuperAdmin == undefined ? undefined : {
                asSuperAdmin: asSuperAdmin
            },
            errorPolicy: 'all',
            variables: {
                // XXX Though SpaceRestrictionCheckProps defines spaceKey as required,
                // SpaceBaseComponent is not written in TypeScript and it may provide
                // undefined as it is reading spaceKey from redux. While it would result
                // in a better separation of concerns to have a fix in SpaceBaseComponent,
                // such a fix would be riskier.
                spaceKey: spaceKey || stateSpaceKey
            }
        }));
        data = result.data;
        error = result.error;
        loading = result.loading;
    } else {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const result = (0, $j1Ss3.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations
        (0, $6wbAc.SpaceRestrictionCheckQuery), {
            context: asSuperAdmin == undefined ? undefined : {
                asSuperAdmin: asSuperAdmin
            },
            fetchPolicy: superAdminClaim ? 'no-cache' : 'network-only',
            errorPolicy: 'all',
            variables: {
                // XXX Though SpaceRestrictionCheckProps defines spaceKey as required,
                // SpaceBaseComponent is not written in TypeScript and it may provide
                // undefined as it is reading spaceKey from redux. While it would result
                // in a better separation of concerns to have a fix in SpaceBaseComponent,
                // such a fix would be riskier.
                spaceKey: spaceKey || stateSpaceKey
            }
        });
        data = result.data;
        error = result.error;
        loading = result.loading;
    }
    let isErrorHandled;
    let isSpaceNotFound;
    let isSpaceRestricted;
    if (error) {
        isSpaceNotFound = $06e8bea7aad8a7b8$export$498e7daa29ea2c61(error);
        isSpaceRestricted = $06e8bea7aad8a7b8$export$ee3dd1f0a88cef(error);
        if (isSpaceNotFound || isSpaceRestricted) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            isErrorHandled = true;
        }
    } else if (data) {
        isSpaceNotFound = false;
        isSpaceRestricted = false;
    }
    if ((0, $6mKj3.expVal)('confluence_restrictions_fix', 'isEnabled', false)) {
        if (loading) return null;
        return children({
            error: error,
            isSpaceNotFound: isSpaceNotFound,
            isSpaceRestricted: isSpaceRestricted
        });
    } else return children({
        error: isErrorHandled ? undefined : error,
        isSpaceNotFound: isSpaceNotFound,
        isSpaceRestricted: isSpaceRestricted,
        loading: loading
    });
}
function $06e8bea7aad8a7b8$export$498e7daa29ea2c61(error) {
    return $06e8bea7aad8a7b8$var$isSpaceError(error, ({ statusCode: statusCode })=>statusCode === 404 || statusCode === 400);
}
function $06e8bea7aad8a7b8$export$ee3dd1f0a88cef(error) {
    return $06e8bea7aad8a7b8$var$isSpaceError(error, ()=>(0, $1uFM6.isUnauthorizedError)(error));
}
function $06e8bea7aad8a7b8$var$isSpaceError({ graphQLErrors: graphQLErrors }, extensionsPredicate) {
    if (graphQLErrors && graphQLErrors.length > 0) for (const { extensions: extensions, path: path } of graphQLErrors){
        if (Array.isArray(path) && path.indexOf('space') !== -1 && extensions && extensionsPredicate(extensions)) return true;
    }
    return false;
}
module.exports["SpaceRestrictionCheck"] = $06e8bea7aad8a7b8$export$f1b4255eb8ae314e;
module.exports["isSpaceNotFoundError"] = $06e8bea7aad8a7b8$export$498e7daa29ea2c61;
module.exports["isSpaceRestrictedError"] = $06e8bea7aad8a7b8$export$ee3dd1f0a88cef;

});

parcelRegister("6wbAc", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $852cc06e57df817b$export$83b038038df2eb9 = (0, $eSUdr.default)`query SpaceRestrictionCheckQuery($spaceKey:String!){space(key:$spaceKey){id settings{routeOverrideEnabled}}}`;
module.exports["SpaceRestrictionCheckQuery"] = $852cc06e57df817b$export$83b038038df2eb9;

});

parcelRegister("kVysQ", function(module, exports) {
const $35b50a968705ed01$export$9960fc620d4470dd = 'comments';
const $35b50a968705ed01$export$c4d483efe8eba686 = 'link-to-page';
const $35b50a968705ed01$export$1de09ba64e7728f2 = 'main-layout';
const $35b50a968705ed01$export$586856ecee8f0723 = 'manage-watcher-dialog';
const $35b50a968705ed01$export$51f018e0f9f84a74 = 'Navigation';
const $35b50a968705ed01$export$94afb8303c61d07d = 'navigation-fmp';
const $35b50a968705ed01$export$fe596581250cd9fc = 'side-navigation-fmp';
const $35b50a968705ed01$export$88c949ed1e388f68 = 'NavigationView';
const $35b50a968705ed01$export$1a3cc5086fadf289 = 'recent-dropdown';
const $35b50a968705ed01$export$b35db70015797a33 = 'resolved-inline-comments-dialog';
const $35b50a968705ed01$export$5c78998b70cdff69 = 'copy-page-tree';
const $35b50a968705ed01$export$1167e4f56227df4c = 'space-directory';
module.exports["PERFORMANCE_SUBJECT_linkToPage"] = $35b50a968705ed01$export$c4d483efe8eba686;
module.exports["PERFORMANCE_SUBJECT_mainLayout"] = $35b50a968705ed01$export$1de09ba64e7728f2;
module.exports["PERFORMANCE_SUBJECT_manageWatcherDialog"] = $35b50a968705ed01$export$586856ecee8f0723;
module.exports["PERFORMANCE_SUBJECT_navigation"] = $35b50a968705ed01$export$51f018e0f9f84a74;
module.exports["PERFORMANCE_SUBJECT_navigationFMP"] = $35b50a968705ed01$export$94afb8303c61d07d;
module.exports["PERFORMANCE_SUBJECT_sideNavigationFMP"] = $35b50a968705ed01$export$fe596581250cd9fc;
module.exports["PERFORMANCE_SUBJECT_navigationView"] = $35b50a968705ed01$export$88c949ed1e388f68;
module.exports["PERFORMANCE_SUBJECT_recentDropdown"] = $35b50a968705ed01$export$1a3cc5086fadf289;
module.exports["PERFORMANCE_SUBJECT_resolvedInlineCommentsDialog"] = $35b50a968705ed01$export$b35db70015797a33;
module.exports["PERFORMANCE_SUBJECT_copyPageTree"] = $35b50a968705ed01$export$5c78998b70cdff69;
module.exports["PERFORMANCE_SUBJECT_spaceDirectory"] = $35b50a968705ed01$export$1167e4f56227df4c;

});

parcelRegister("4NX9d", function(module, exports) {

var $4xcIM = parcelRequire("4xcIM");


var $42omo = parcelRequire("42omo");


var $9eE57 = parcelRequire("9eE57");

class $6182ff2f7ce21920$export$c7a09306845216e0 extends (0, $42omo.Component) {
    componentDidMount() {
        (0, $9eE57.perfMarkEnd)(this.props);
    }
    render() {
        return null;
    }
}
$6182ff2f7ce21920$export$c7a09306845216e0.propTypes = {
    subject: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    subjectId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    details: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    includeFeatureFlags: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
};
$6182ff2f7ce21920$export$c7a09306845216e0.defaultProps = {
    subjectId: '',
    includeFeatureFlags: false
};
module.exports["PerformanceEnd"] = $6182ff2f7ce21920$export$c7a09306845216e0;

});

parcelRegister("6CEg5", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");


var $9eE57 = parcelRequire("9eE57");

class $dc6daeb5b2d3b455$export$616e8efc277d5c6 extends (0, $42omo.Component) {
    componentDidMount() {
        const { markBeforeMount: markBeforeMount, subject: subject, subjectId: subjectId } = this.props;
        if (!markBeforeMount) (0, $9eE57.perfMarkStart)({
            subject: subject,
            subjectId: subjectId
        });
    }
    render() {
        return null;
    }
    constructor(props){
        super(props);
        if (props.markBeforeMount) {
            const { subject: subject, subjectId: subjectId } = this.props;
            (0, $9eE57.perfMarkStart)({
                subject: subject,
                subjectId: subjectId
            });
        }
    }
}
$dc6daeb5b2d3b455$export$616e8efc277d5c6.propTypes = {
    subject: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    subjectId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    markBeforeMount: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
};
$dc6daeb5b2d3b455$export$616e8efc277d5c6.defaultProps = {
    subjectId: '',
    markBeforeMount: false
};
module.exports["PerformanceStart"] = $dc6daeb5b2d3b455$export$616e8efc277d5c6;

});

parcelRegister("lEf66", function(module, exports) {
const $0892e7364b81f0d9$export$256d0139ed1b4d96 = (queryData)=>{
    return queryData?.user?.confluence?.permissionType;
};
module.exports["getUserPermissionFromQuery"] = $0892e7364b81f0d9$export$256d0139ed1b4d96;

});

parcelRegister("b8XTE", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $a4TK8 = parcelRequire("a4TK8");


var $3kTfj = parcelRequire("3kTfj");


var $1NBp8 = parcelRequire("1NBp8");


var $78QFu = parcelRequire("78QFu");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");


var $lXYVJ = parcelRequire("lXYVJ");

const $eb0c119b7155e6d7$var$noop = ()=>{};
const $eb0c119b7155e6d7$var$PageSegmentLoadEndComponent = /*#__PURE__*/ (0, $42omo.memo)(({ customData: customData = {}, metric: metric, onComplete: onComplete = $eb0c119b7155e6d7$var$noop, stopTime: stopTime, timing: timing, augmentCustomDataAfterComplete: augmentCustomDataAfterComplete })=>{
    // Use refs to avoid firing handlePageSegmentLoadMetricStop more than once despite changes to stopTime or customData
    const stopTimeRef = (0, $42omo.useRef)(stopTime);
    const customDataRef = (0, $42omo.useRef)(customData);
    const augmentCustomDataAfterCompleteRef = (0, $42omo.useRef)(augmentCustomDataAfterComplete);
    stopTimeRef.current = stopTime;
    customDataRef.current = customData;
    augmentCustomDataAfterCompleteRef.current = augmentCustomDataAfterComplete;
    const handlePageSegmentLoadMetricStop = (0, $42omo.useCallback)(()=>{
        if (metric) {
            onComplete();
            let finalCustomData;
            if (augmentCustomDataAfterCompleteRef.current) finalCustomData = augmentCustomDataAfterCompleteRef.current(customDataRef.current);
            else finalCustomData = customDataRef.current;
            const { route: route } = metric.getData();
            const shouldAddViewTransitionSource = route === (0, $1NBp8.VIEW_PAGE).name || route === (0, $1NBp8.VIEW_BLOG).name;
            if (shouldAddViewTransitionSource) finalCustomData.viewTransitionSource = (0, $lXYVJ.getViewTransitionSource)();
            (0, $3kTfj.browserMetrics).getPageLoadMetric().mark(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${metric.key}`);
            metric.stop({
                customData: {
                    ...finalCustomData,
                    previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
                    previousContentId: (0, $6VdZc.browserMetricsState).previousContentId,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                },
                stopTime: stopTimeRef.current
            });
        }
    }, [
        metric,
        onComplete
    ]);
    (0, $N1nBh.usePerformanceAction)(handlePageSegmentLoadMetricStop, timing);
    return null;
}, /**
	 * Use lodash isEqual as comparator to avoid unnecessary re-renders
	 * i.e. when an object is defined directly within customData prop
	 * `<PageLoadSegmentEnd ... customData={{ data: 'example' }} />`
	 * (Export only for testing)
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
const $eb0c119b7155e6d7$export$a267cdf45880b07b = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($eb0c119b7155e6d7$var$PageSegmentLoadEndComponent);
module.exports["PageSegmentLoadEnd"] = $eb0c119b7155e6d7$export$a267cdf45880b07b;

});

parcelRegister("lXYVJ", function(module, exports) {

var $1C3B1 = parcelRequire("1C3B1");

let $3ef2d7a9f25e0216$var$transitionSource;
const $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5 = (source)=>{
    $3ef2d7a9f25e0216$var$transitionSource = source;
};
const $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0 = ()=>{
    return $3ef2d7a9f25e0216$var$transitionSource || (0, $1C3B1.UNKNOWN);
};
const $3ef2d7a9f25e0216$export$6dffe64fdadf1e02 = ()=>{
    $3ef2d7a9f25e0216$var$transitionSource = undefined;
};
module.exports["setViewTransitionSource"] = $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5;
module.exports["getViewTransitionSource"] = $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0;
module.exports["resetViewTransitionSource"] = $3ef2d7a9f25e0216$export$6dffe64fdadf1e02;

});

parcelRegister("1C3B1", function(module, exports) {
const $f3fed16e32582dfc$export$f32efcfda8942c38 = 'PAGE_TREE_ITEM_CLICK';
const $f3fed16e32582dfc$export$e20b00d7fdb37fd5 = 'RECENT_DROPDOWN_ITEM_CLICK';
const $f3fed16e32582dfc$export$861af28956854f4d = 'EDITOR_UPDATE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$3a68be40f6a0cf8d = 'EDITOR_UPDATE_SHORTCUT_KEY_PRESS';
const $f3fed16e32582dfc$export$14ad6d5644be3ef2 = 'EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK';
const $f3fed16e32582dfc$export$26bf8dd7a8a304a2 = 'EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS';
const $f3fed16e32582dfc$export$35f8dbb53e30cb83 = 'EDITOR_CLOSE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$56128408995abf4c = 'RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$c6abfcd7964138ae = 'DISCOVER_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$78244dbb77cfa6b6 = 'UNKNOWN';
module.exports["PAGE_TREE_ITEM_CLICK"] = $f3fed16e32582dfc$export$f32efcfda8942c38;
module.exports["RECENT_DROPDOWN_ITEM_CLICK"] = $f3fed16e32582dfc$export$e20b00d7fdb37fd5;
module.exports["EDITOR_UPDATE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$861af28956854f4d;
module.exports["EDITOR_UPDATE_SHORTCUT_KEY_PRESS"] = $f3fed16e32582dfc$export$3a68be40f6a0cf8d;
module.exports["EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK"] = $f3fed16e32582dfc$export$14ad6d5644be3ef2;
module.exports["EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS"] = $f3fed16e32582dfc$export$26bf8dd7a8a304a2;
module.exports["EDITOR_CLOSE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$35f8dbb53e30cb83;
module.exports["RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$56128408995abf4c;
module.exports["DISCOVER_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$c6abfcd7964138ae;
module.exports["UNKNOWN"] = $f3fed16e32582dfc$export$78244dbb77cfa6b6;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;
module.exports["forgeGlobalExtensions"] = $af2b0e533822f413$export$492ceb220fc48ad2;

});

parcelRegister("lkcsM", function(module, exports) {
/* PageTreeLinkItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $e4o8D = parcelRequire("e4o8D");

const $851dc1c722008886$var$HIGHLIGHT_FADE = null;
const $851dc1c722008886$var$notchColorVar = '--notch-color';
const $851dc1c722008886$var$notchStyles = null;
const $851dc1c722008886$var$getElementBeforeColor = (draggableState, isNav4Enabled)=>{
    if (draggableState === 'dragging') return "var(--ds-icon-disabled, #080F214A)";
    if (isNav4Enabled) return "var(--ds-icon, #292A2E)";
    return "var(--ds-icon-accent-gray, #7D818A)";
}; // Note: this component extracts the props that we don't want to send to the DOM
// This avoids styled errors about these props being passed to the DOM
/* eslint-disable @typescript-eslint/no-unused-vars */ const $851dc1c722008886$var$ElementBeforeBase = ({ isSelected: isSelected, draggableState: draggableState, isNav4Enabled: isNav4Enabled, children: children, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", props, children);
}; /* eslint-enable @typescript-eslint/no-unused-vars */ 
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $851dc1c722008886$var$ElementBefore = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = $851dc1c722008886$var$ElementBeforeBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1pbykb7n _1e0c1txw _4t3i1tcg _1bsb1tcg _cae71h6o _1y4p1h6o _4cvr1h6o _1bah1h6o _1o9zidpf _syaz2sac",
            __cmplp.isNav4Enabled ? "_2hwxze3t" : "_2hwxu2gc",
            __cmplp.isNav4Enabled ? "_18u01b66" : "_18u0u2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $851dc1c722008886$var$ElementAfter = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1o9zidpf _18u0utpp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $851dc1c722008886$var$LinkItemContent = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _1e0c1txw _1tke1tcg _1dth1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
}); /**
     *  Use before element + z-index to create a pseudo background. There's no plan to indent the hover and active states
     *  on the main item. The indenting here is still important so that reparenting matches the indent of the "merge"
     *  outline + the drop indicator.
     */ 
const $851dc1c722008886$var$ReparentBackground = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_rfx3fajl _1cs8stnw _1g0vidpf _1kt9b3bt _1rusufnl _kfgt1osq _1aukidpf _qnecidpf _oounidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $851dc1c722008886$var$TitleSpan = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _12ji1r31 _1qu2glyw _12y31o36 _c95nt94y _16jlkb7n _y3gn1e5h _1e0c1txw _2lx21bp4 _1pbykb7n",
            __cmplp.className
        ])
    });
});
const $851dc1c722008886$export$4a5b409614923c3a = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isNav4Enabled: isNav4Enabled, indent: indent, isSelected: isSelected, forceHoverBackground: forceHoverBackground, isSuperAdmin: isSuperAdmin, item: item, draggableState: draggableState, isDisabled: isDisabled, isQuickActionsFocused: isQuickActionsFocused, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_gg0ene": (0, $7sObp.default)(__cmplp.indent, "px"),
            "--_1loki36": (0, $7sObp.default)(`${__cmplp.indent}px`),
            "--_1j6sbvc": (0, $7sObp.default)(`-${__cmplp.indent}px`)
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rkofajl _19itglyw _11c82smr _4bfu1r31 _1hmsglyw _ajmmnqa1 _kqswh2mm _1e0c1txw _4cvr1h6o _80omtlke _1tke1tcg _vchhusvi _1dth1h6o _bfhk1j28 _1yyu1j28 _uiztglyw _syazazsu _1nrm1r31 _1a3b1r31 _9oik1r31 _1ydc1r31 _c2waglyw _4fprglyw _1bnxglyw _1x28glyw _1iohnqa1 _5goinqa1 _jf4cnqa1 _1726nqa1 _9h8hazsu _f8pjazsu _30l3azsu _1053azsu _nt751r31 _49pcglyw _1hvw1o36 _7ehi12pz _u31nplhp _10j71dpa _irr31dpa _1vvz1j28 _984x1j28 _18bl1txw _1qdc1txw _tfd31osq _1p0e1osq _r8b6glyw _iusrglyw _7919f1ug _55b3f1ug _n7dwglyw _180dglyw _1di615s3 _jomr15s3",
            __cmplp.isNav4Enabled ? "_1bsb1bfw" : "_1bsb1osq",
            __cmplp.isNav4Enabled ? "_4t3izwfg" : "_4t3i14no",
            __cmplp.isNav4Enabled ? "_18s81ymq" : "_19pkgrf3 _2hwxgrf3 _otyrgrf3 _18u0grf3",
            __cmplp.isNav4Enabled ? "_ca0qidpf _u5f31y44 _n3tdidpf _19bvidpf" : "_1yt41mx4",
            __cmplp.isNav4Enabled && "_1kt9f705 _1mp49jde _fntn1uia _kfgt1tcg",
            __cmplp.isSelected && "_bfhk15s3 _1yyujmqp _10j7ufnl _irr3ufnl _zxzajmqp _u31njmqp",
            __cmplp.forceHoverBackground && "_bfhk1dpa",
            __cmplp.isSelected && "_9h8h6x5g _f8pj6x5g _10536x5g _30l316jw",
            __cmplp.isSuperAdmin && (__cmplp.item.hasRestrictions || __cmplp.item.hasInheritedRestrictions) && "_syaz1tmw",
            __cmplp.draggableState === 'dragging' && "_a0k61gmx",
            __cmplp.isDisabled && "_80om73ad _a0k61gmx _1di61j28 _jomr1j28 _irr31j28 _nkjn1j28",
            __cmplp.forceHoverBackground || __cmplp.isQuickActionsFocused ? "_7ggv1txw" : "_7ggvglyw",
            __cmplp.forceHoverBackground || __cmplp.isQuickActionsFocused ? "_1ieu1osq" : "_1ieuf1ug",
            __cmplp.item.data.status === 'DRAFT' && "_bye315iw",
            __cmplp.item.data.isHighlighted && "",
            __cmplp.item.data.isHighlighted && "_j7hq192d _5sagymdr _1pglp3kn",
            __cmplp.item.data.type === 'folder' && __cmplp.draggableState === 'dragging' && "_148g1gmx",
            __cmplp.className
        ])
    });
});
const $851dc1c722008886$export$55136cee40306062 = 'page';
const $851dc1c722008886$var$scrollOptions = {
    behavior: 'auto',
    block: 'center',
    inline: 'nearest'
}; // there should be a valid calculated layout for `scrollIntoView`
const $851dc1c722008886$export$10cbe96ec013bef7 = `requestAnimationFrame(function() {
  const selected = document.querySelector('[aria-current="${$851dc1c722008886$export$55136cee40306062}"]');
  if(selected) selected.scrollIntoView(${JSON.stringify($851dc1c722008886$var$scrollOptions)});
  });
  `; /**
      * This needs to be placed at the end of side navigation.
      * Because we need to execute it synchronously to allow scroll to be fast.
      * But we can only execute when everything is parsed in the side bar to get the correct scroll position.
      * Also this script is executed as inline script in SSR result as well as in SPA code to avoid jumping.
      *
      * When blog tree is showing and expanded, it will also use this exact
      * script to scroll to the selected blog tree item. We apply the same focusedAriaCurrentValue to the selected blog tree item.
      */ 
const $851dc1c722008886$export$7a2fdc23a3f02c8a = ()=>{
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    (0, $42omo.useLayoutEffect)(()=>{
        if (window.__SSR_RENDERED__) {
            const script = document.createElement('script');
            script.appendChild(document.createTextNode($851dc1c722008886$export$10cbe96ec013bef7));
            document.body.appendChild(script);
            return ()=>{
                document.body.removeChild(script);
            };
        }
    }, []);
    if (renderServerPlaceholder) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("script", {
        /* eslint-disable-next-line react/no-danger */ dangerouslySetInnerHTML: {
            __html: $851dc1c722008886$export$10cbe96ec013bef7
        }
    });
    return null;
};
const $851dc1c722008886$export$7a662285bdfa3afe = ({ afterIcon: afterIcon, beforeIcon: beforeIcon, children: children, draggableState: draggableState, dragHandleProps: dragHandleProps, indent: indent, isSelected: isSelected, href: href, isNav4Enabled: isNav4Enabled, isDisabled: isDisabled, ...passThroughPageTreeLinkProps })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($851dc1c722008886$export$4a5b409614923c3a, {
        ...dragHandleProps,
        ...passThroughPageTreeLinkProps,
        // This will break the page as inside the link there is another <button>
        // <button> can't be rendered inside another <button>
        href: !isDisabled ? href || '#' : undefined,
        "aria-current": isSelected ? $851dc1c722008886$export$55136cee40306062 : undefined,
        "data-testid": "page-tree-item",
        draggableState: draggableState,
        indent: indent,
        isSelected: isSelected,
        isNav4Enabled: isNav4Enabled,
        isDisabled: isDisabled,
        "aria-disabled": isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($851dc1c722008886$var$LinkItemContent, null, isNav4Enabled && !isDisabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "aria-hidden": "true",
        className: (0, $gMc0m.default)([
            "_kqswstnw _152t1ssb _1e02ze3t _1bsbyh40 _4t3i1crf _t9ec1i34 _bfhk1o0g"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($851dc1c722008886$var$ElementBefore, {
        isSelected: isSelected,
        draggableState: draggableState,
        isNav4Enabled: isNav4Enabled
    }, beforeIcon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($851dc1c722008886$var$TitleSpan, null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($851dc1c722008886$var$ElementAfter, null, afterIcon)), draggableState === 'parent-of-instruction' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($851dc1c722008886$var$ReparentBackground, {
        "data-testid": "reparent-background"
    }) : null);
};
module.exports["focusedAriaCurrentValue"] = $851dc1c722008886$export$55136cee40306062;
module.exports["FocusToCurrentPageTreeLinkItemSSRInlineScript"] = $851dc1c722008886$export$7a2fdc23a3f02c8a;
module.exports["PageTreeLinkItem"] = $851dc1c722008886$export$7a662285bdfa3afe;

});

parcelRegister("e4o8D", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $2679ebd914f0a083$export$96e8e9e8e57310bb = (renderServerPlaceholderOnNonHydrate = false)=>{
    const isTransition = window.__SSR_RENDERED__ === false;
    const [renderServerPlaceholder, setRenderServerPlaceholder] = (0, $42omo.useState)(renderServerPlaceholderOnNonHydrate ? !isTransition || Boolean(undefined) : window?.__HYDRATABLE__ && !isTransition || Boolean(undefined));
    (0, $42omo.useEffect)(()=>{
        setRenderServerPlaceholder(false);
    }, []);
    return renderServerPlaceholder;
};
module.exports["useRenderServerPlaceholder"] = $2679ebd914f0a083$export$96e8e9e8e57310bb;

});

parcelRegister("jFmKR", function(module, exports) {

var $xQxzY = parcelRequire("xQxzY");


var $eSUdr = parcelRequire("eSUdr");

const $da0a91219ee54603$export$b1d9964175452d0b = ({ spaceKey: spaceKey, skipQuery: skipQuery })=>{
    const { data: data, loading: loading, error: error } = (0, $xQxzY.useQuery)((0, $eSUdr.gql)`
			query useIsUserViewingSpaceAsAnonQuery($spaceKey: String) {
				space(key: $spaceKey) {
					id
					currentUser {
						isAnonymouslyAuthorized
					}
				}
			}
		`, {
        variables: {
            spaceKey: spaceKey
        },
        skip: skipQuery || !spaceKey
    });
    return {
        isUserViewingSpaceAsAnon: Boolean(data?.space?.currentUser?.isAnonymouslyAuthorized),
        loading: loading,
        error: error
    };
};
module.exports["useIsUserViewingSpaceAsAnon"] = $da0a91219ee54603$export$b1d9964175452d0b;

});

parcelRegister("de2j9", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");

const $da4a5d353aff754e$var$isOnEditorPageRouteArgs = {
    selector: (routeName)=>routeName === (0, $1NBp8.EDIT_PAGE_V2).name || routeName === (0, $1NBp8.EDIT_BLOG_V2).name || routeName === (0, $1NBp8.EDIT_PAGE_EMBED).name || routeName === (0, $1NBp8.COMPANY_HUB_EDIT).name || routeName === (0, $1NBp8.HUB_EDIT).name || routeName === (0, $1NBp8.EDIT_PAGE_SMART_CREATE).name
};
const $da4a5d353aff754e$export$90b90ac8ec152a49 = ()=>(0, $dPJCf.useRouteName)($da4a5d353aff754e$var$isOnEditorPageRouteArgs);
module.exports["useIsEditorPage"] = $da4a5d353aff754e$export$90b90ac8ec152a49;

});

parcelRegister("15oJr", function(module, exports) {

let $0ca9715086741dc5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0ca9715086741dc5$var$load("TkY5q").then(()=>parcelRequire('4Ym1v'));

});

parcelRegister("8q3aB", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $9090acc33078fd99$export$40bc69a2d697f368 = (0, $eSUdr.default)`query SpaceNavigationQuery($spaceKey:String$isLicensed:Boolean!){user:confluence_atlassianUser(current:true){id confluence{permissionType}}spaceSidebarLinks(spaceKey:$spaceKey){main(includeHidden:true){id webItemKey webItemCompleteKey title url position styleClass icon{path width height isDefault}iconClass hidden canHide tooltip linkIdentifier type}quick{id url position title styleClass}}space(key:$spaceKey){id key name type status icon{path}homepage{id}currentUser@include(if:$isLicensed){isAdmin isFavourited isWatched}operations{operation targetType}containsExternalCollaborators history{createdDate}didContainUserContent}}`;
module.exports["SpaceNavigationQuery"] = $9090acc33078fd99$export$40bc69a2d697f368;

});

parcelRegister("cpa7E", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $9fBoq = parcelRequire("9fBoq");


var $28oQf = parcelRequire("28oQf");


var $jSwpw = parcelRequire("jSwpw");

const $b58a0883d14838f7$export$651e7ee720a56f40 = (spaceKey, links, forgeApps, isSpaceAdmin)=>{
    const forgeAppsMap = forgeApps.reduce((acc, app)=>{
        return acc.set(app.id, app);
    }, new Map());
    const allAppLinks = links.filter((link)=>$b58a0883d14838f7$export$624f6de9302f0d2d(link) && !$b58a0883d14838f7$var$isBuiltInItem(link) || $b58a0883d14838f7$export$967356d6bd08d9d2(link) && forgeAppsMap.has(link.linkIdentifier))// Fill in links for Forge apps
    .map((link)=>{
        if (!$b58a0883d14838f7$export$967356d6bd08d9d2(link)) return link;
        const forgeApp = forgeAppsMap.get(link.linkIdentifier);
        return {
            ...link,
            url: $b58a0883d14838f7$export$9d0f88f6a47d6004(spaceKey, forgeApp),
            title: (0, $9fBoq.extensionTitle)(forgeApp),
            icon: {
                width: null,
                height: null,
                isDefault: null,
                path: forgeApp.properties.icon || ''
            }
        };
    }).sort((a, b)=>Number(a.position) - Number(b.position));
    // Adding forge apps that are not in the links yet
    // This could be possible for new installed forge apps
    const allForgeLinksIds = allAppLinks.filter($b58a0883d14838f7$export$967356d6bd08d9d2).map((link)=>link.linkIdentifier);
    forgeApps.forEach((forgeApp)=>{
        if (!allForgeLinksIds.includes(forgeApp.id)) {
            const forgeAppLink = {
                id: forgeApp.id,
                type: (0, $jSwpw.SpaceSidebarLinkType).FORGE,
                linkIdentifier: forgeApp.id,
                position: 0,
                hidden: false,
                webItemKey: null,
                webItemCompleteKey: null,
                title: (0, $9fBoq.extensionTitle)(forgeApp),
                url: $b58a0883d14838f7$export$9d0f88f6a47d6004(spaceKey, forgeApp),
                styleClass: null,
                icon: {
                    path: forgeApp.properties.icon || '',
                    width: null,
                    height: null,
                    isDefault: null
                },
                iconClass: null,
                canHide: null,
                tooltip: null,
                properties: forgeApp.properties
            };
            allAppLinks.push(forgeAppLink);
        }
    });
    const appsHidden = links.filter(({ webItemCompleteKey: webItemCompleteKey, hidden: hidden })=>webItemCompleteKey === (0, $28oQf.APPS_KEY) && hidden).length > 0;
    const allVisibleAppLinks = allAppLinks.filter((link)=>!link.hidden);
    const shouldRenderSpaceApps = !appsHidden && !(allAppLinks.length == 0 || allVisibleAppLinks.length == 0 && !isSpaceAdmin);
    return {
        allAppLinks: allAppLinks,
        allVisibleAppLinks: allVisibleAppLinks,
        shouldRenderSpaceApps: shouldRenderSpaceApps
    };
};
const $b58a0883d14838f7$export$9d0f88f6a47d6004 = (spaceKey, app)=>{
    return (0, $1NBp8.SPACE_FORGE_APPS).toUrl({
        spaceKey: spaceKey,
        appId: app.appId,
        envId: app.environmentId,
        forgeManifestRoute: app.properties.route
    });
};
const $b58a0883d14838f7$export$624f6de9302f0d2d = (link)=>{
    return link.webItemCompleteKey?.startsWith((0, $28oQf.CONNECT_ADDON_KEY));
};
const $b58a0883d14838f7$export$967356d6bd08d9d2 = (link)=>{
    return link.type === (0, $jSwpw.SpaceSidebarLinkType).FORGE && link.linkIdentifier;
};
const $b58a0883d14838f7$var$isBuiltInItem = (link)=>{
    const builtInItems = [
        (0, $28oQf.ANALYTICS_KEY),
        (0, $28oQf.ANALYTICS_KEY_MODERATE),
        (0, $28oQf.QUESTIONS_KEY),
        (0, $28oQf.DATABASES_KEY)
    ];
    return builtInItems.includes(link.webItemCompleteKey);
};
module.exports["getAllAppLinks"] = $b58a0883d14838f7$export$651e7ee720a56f40;
module.exports["isConnectApp"] = $b58a0883d14838f7$export$624f6de9302f0d2d;
module.exports["isForgeApp"] = $b58a0883d14838f7$export$967356d6bd08d9d2;

});

parcelRegister("9fBoq", function(module, exports) {
parcelRequire("1c598");
var $1Aku8 = parcelRequire("1Aku8");

const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $1Aku8.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $1Aku8.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};
module.exports["extensionTitle"] = $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e;

});

parcelRegister("1c598", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);
parcelRequire("i3Ypo");
var $2JC3k = parcelRequire("2JC3k");
var $1Aku8 = parcelRequire("1Aku8");
var $9dbGT = parcelRequire("9dbGT");

parcelRequire("jUCNB");
var $gUjm2 = parcelRequire("gUjm2");
var $kg3OT = parcelRequire("kg3OT");
var $fsQJy = parcelRequire("fsQJy");


});

parcelRegister("i3Ypo", function(module, exports) {
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);

var $9dbGT = parcelRequire("9dbGT");


var $1Aku8 = parcelRequire("1Aku8");


var $6sM2K = parcelRequire("6sM2K");


var $2JC3k = parcelRequire("2JC3k");


});

parcelRegister("9dbGT", function(module, exports) {
const $1ec3e8240f57817b$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $1ec3e8240f57817b$export$3ee8c58bb87b9685 = [
    ...$1ec3e8240f57817b$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];
module.exports["MarkupRecursiveList"] = $1ec3e8240f57817b$export$3b98ab6402702476;
module.exports["MarkupList"] = $1ec3e8240f57817b$export$3ee8c58bb87b9685;

});

parcelRegister("1Aku8", function(module, exports) {
var $d128cc36ec70c56c$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $d128cc36ec70c56c$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $d128cc36ec70c56c$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $d128cc36ec70c56c$export$beaef1891b3e7ca3;

});

parcelRegister("6sM2K", function(module, exports) {
const $0e3337cb4407ef3b$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("2JC3k", function(module, exports) {
var $d977f97374f9d2c9$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $d977f97374f9d2c9$export$9a2372818e2520c6 = {
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    TEST_MODULE: 'test:module'
};
const $d977f97374f9d2c9$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};
module.exports["ExtensionEnvironment"] = $d977f97374f9d2c9$export$6e95f5308d9156f9;
module.exports["ConfluenceExtension"] = $d977f97374f9d2c9$export$9a2372818e2520c6;
module.exports["JiraExtension"] = $d977f97374f9d2c9$export$f06ffa3aa6bfec95;

});

parcelRegister("jUCNB", function(module, exports) {

var $fsQJy = parcelRequire("fsQJy");


var $kg3OT = parcelRequire("kg3OT");


var $gUjm2 = parcelRequire("gUjm2");


});

parcelRegister("fsQJy", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $8d78496ee677e86d$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $8d78496ee677e86d$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $8d78496ee677e86d$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $8d78496ee677e86d$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $8d78496ee677e86d$export$20b9f6acb0888554(effect) {
    return $8d78496ee677e86d$export$7e816460364ed464(effect) || $8d78496ee677e86d$export$eb5bd7f371e458af(effect) || $8d78496ee677e86d$export$f632ad3064955f31(effect);
}

});

parcelRegister("kg3OT", function(module, exports) {
const $bc3454970f51a505$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $bc3454970f51a505$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $bc3454970f51a505$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $bc3454970f51a505$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $bc3454970f51a505$export$caa8cab0db5b0a61(effect) {
    return $bc3454970f51a505$export$65d7078e01574f24(effect) || $bc3454970f51a505$export$709a27a9f80556b8(effect) || $bc3454970f51a505$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("gUjm2", function(module, exports) {
// From forge.ts
const $ce9f8921033c0d6d$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $ce9f8921033c0d6d$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $ce9f8921033c0d6d$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $ce9f8921033c0d6d$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $ce9f8921033c0d6d$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $ce9f8921033c0d6d$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $ce9f8921033c0d6d$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $ce9f8921033c0d6d$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $ce9f8921033c0d6d$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $ce9f8921033c0d6d$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $ce9f8921033c0d6d$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});

parcelRegister("28oQf", function(module, exports) {
const $a5e3205ff2d8ec91$export$38788381122702f5 = 'com.atlassian.plugins.atlassian-connect-plugin:space-navigation-web-item-com-addonengine-analytics-space-analytics';
const $a5e3205ff2d8ec91$export$6c3d789a4f56bea2 = 'com.atlassian.plugins.atlassian-connect-plugin:space-navigation-web-item-com-addonengine-analytics-moderate-space-analytics';
const $a5e3205ff2d8ec91$export$ee99bc1ad01a63ae = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-automation';
const $a5e3205ff2d8ec91$export$dad26f289a3f773e = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-blogs';
const $a5e3205ff2d8ec91$export$27d01545acc1e1ca = 'com.atlassian.confluence.extra.team-calendars:space-calendar-sidebar-link';
const $a5e3205ff2d8ec91$export$a1081c7e806b45a0 = 'com.atlassian.plugins.atlassian-connect-plugin:space-navigation-web-item-com-k15t-orderly-databases-database';
const $a5e3205ff2d8ec91$export$de45ec31104af09 = 'com.atlassian.plugins.atlassian-connect-plugin:space-navigation-web-item-com-atlassian-confluence-plugins-confluence-questions-question';
const $a5e3205ff2d8ec91$export$1b86edccef2dd51 = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-questions';
const $a5e3205ff2d8ec91$export$f618e448a4ddfafa = 'com.atlassian.confluence.plugins.confluence-frontend-support:space-tools-link';
const $a5e3205ff2d8ec91$export$9727611105a72ba4 = 'com.atlassian.plugins.atlassian-connect-plugin';
const $a5e3205ff2d8ec91$export$35d69df876e79a8b = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-shortcuts';
const $a5e3205ff2d8ec91$export$28596511f20e98f2 = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-apps';
const $a5e3205ff2d8ec91$export$1c0f21b83a6a96d6 = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-content-manager';
module.exports["ANALYTICS_KEY"] = $a5e3205ff2d8ec91$export$38788381122702f5;
module.exports["ANALYTICS_KEY_MODERATE"] = $a5e3205ff2d8ec91$export$6c3d789a4f56bea2;
module.exports["AUTOMATION_KEY"] = $a5e3205ff2d8ec91$export$ee99bc1ad01a63ae;
module.exports["BLOG_KEY"] = $a5e3205ff2d8ec91$export$dad26f289a3f773e;
module.exports["CALENDARS_KEY"] = $a5e3205ff2d8ec91$export$27d01545acc1e1ca;
module.exports["DATABASES_KEY"] = $a5e3205ff2d8ec91$export$a1081c7e806b45a0;
module.exports["QUESTIONS_KEY"] = $a5e3205ff2d8ec91$export$de45ec31104af09;
module.exports["QUESTIONS_NATIVE_KEY"] = $a5e3205ff2d8ec91$export$1b86edccef2dd51;
module.exports["SPACE_SETTINGS_KEY"] = $a5e3205ff2d8ec91$export$f618e448a4ddfafa;
module.exports["CONNECT_ADDON_KEY"] = $a5e3205ff2d8ec91$export$9727611105a72ba4;
module.exports["SHORTCUTS_KEY"] = $a5e3205ff2d8ec91$export$35d69df876e79a8b;
module.exports["APPS_KEY"] = $a5e3205ff2d8ec91$export$28596511f20e98f2;
module.exports["BULK_TOOLS_KEY"] = $a5e3205ff2d8ec91$export$1c0f21b83a6a96d6;

});

parcelRegister("jSwpw", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $0f145b4629280bb6$export$3da4364c8f760e48 = /*#__PURE__*/ function(SpaceSidebarLinkType) {
    SpaceSidebarLinkType["EXTERNAL_LINK"] = "EXTERNAL_LINK";
    SpaceSidebarLinkType["FORGE"] = "FORGE";
    SpaceSidebarLinkType["PINNED_ATTACHMENT"] = "PINNED_ATTACHMENT";
    SpaceSidebarLinkType["PINNED_BLOG_POST"] = "PINNED_BLOG_POST";
    SpaceSidebarLinkType["PINNED_PAGE"] = "PINNED_PAGE";
    SpaceSidebarLinkType["PINNED_SPACE"] = "PINNED_SPACE";
    SpaceSidebarLinkType["PINNED_USER_INFO"] = "PINNED_USER_INFO";
    SpaceSidebarLinkType["WEB_ITEM"] = "WEB_ITEM";
    return SpaceSidebarLinkType;
}({});
module.exports["SpaceSidebarLinkType"] = $0f145b4629280bb6$export$3da4364c8f760e48;

});

parcelRegister("AF127", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $ba401a956958f707$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
var $ba401a956958f707$export$3da4364c8f760e48 = /*#__PURE__*/ function(SpaceSidebarLinkType) {
    SpaceSidebarLinkType["EXTERNAL_LINK"] = "EXTERNAL_LINK";
    SpaceSidebarLinkType["FORGE"] = "FORGE";
    SpaceSidebarLinkType["PINNED_ATTACHMENT"] = "PINNED_ATTACHMENT";
    SpaceSidebarLinkType["PINNED_BLOG_POST"] = "PINNED_BLOG_POST";
    SpaceSidebarLinkType["PINNED_PAGE"] = "PINNED_PAGE";
    SpaceSidebarLinkType["PINNED_SPACE"] = "PINNED_SPACE";
    SpaceSidebarLinkType["PINNED_USER_INFO"] = "PINNED_USER_INFO";
    SpaceSidebarLinkType["WEB_ITEM"] = "WEB_ITEM";
    return SpaceSidebarLinkType;
}({});
module.exports["SitePermissionType"] = $ba401a956958f707$export$8995abb8169b2cb8;
module.exports["SpaceSidebarLinkType"] = $ba401a956958f707$export$3da4364c8f760e48;

});

parcelRegister("fadJK", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $645e6ce7c101e8d7$export$bc73fcb5b19302e5 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Brz4w",
    name: "Nav3SpaceNavigationContent",
    loader: async ()=>(await (parcelRequire("5Nn82"))).Nav3SpaceNavigationContent
});

const $645e6ce7c101e8d7$export$ec7f7d400376dc53 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "fQj-o",
    name: "SpaceNavigationContent",
    loader: async ()=>(await (parcelRequire("cYet1"))).SpaceNavigationContent
});
module.exports["Nav3SpaceNavigationContent"] = $645e6ce7c101e8d7$export$bc73fcb5b19302e5;
module.exports["SpaceNavigationContent"] = $645e6ce7c101e8d7$export$ec7f7d400376dc53;

});

parcelRegister("5Nn82", function(module, exports) {

let $43837839339c0199$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $43837839339c0199$var$load("6sGtZ"),
    $43837839339c0199$var$load("6EQss"),
    $43837839339c0199$var$load("6wr18"),
    $43837839339c0199$var$load("3NBIF"),
    $43837839339c0199$var$load("g2QSG"),
    $43837839339c0199$var$load("k28dP"),
    $43837839339c0199$var$load("j4CTh"),
    $43837839339c0199$var$load("19uFC"),
    $43837839339c0199$var$load("Wowvf"),
    $43837839339c0199$var$load("awqCy"),
    $43837839339c0199$var$load("jdjSr"),
    $43837839339c0199$var$load("cIHDc"),
    $43837839339c0199$var$load("6vEb6"),
    $43837839339c0199$var$load("ffEVr"),
    $43837839339c0199$var$load("hhss7"),
    $43837839339c0199$var$load("7EorR"),
    $43837839339c0199$var$load("cJHFd")
]).then(()=>parcelRequire('egHHW'));

});

parcelRegister("cYet1", function(module, exports) {

let $97164f8314246c7a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $97164f8314246c7a$var$load("awqCy"),
    $97164f8314246c7a$var$load("6wr18"),
    $97164f8314246c7a$var$load("3NBIF"),
    $97164f8314246c7a$var$load("k28dP"),
    $97164f8314246c7a$var$load("j4CTh"),
    $97164f8314246c7a$var$load("hHrTM"),
    $97164f8314246c7a$var$load("6jw5Q"),
    $97164f8314246c7a$var$load("e2ujj"),
    $97164f8314246c7a$var$load("19uFC"),
    $97164f8314246c7a$var$load("fzHDF"),
    $97164f8314246c7a$var$load("3qsjq"),
    $97164f8314246c7a$var$load("lUlCu"),
    $97164f8314246c7a$var$load("Wowvf"),
    $97164f8314246c7a$var$load("ffEVr"),
    $97164f8314246c7a$var$load("7EorR"),
    $97164f8314246c7a$var$load("fZt2F"),
    $97164f8314246c7a$var$load("hhss7"),
    $97164f8314246c7a$var$load("hFtKc")
]).then(()=>parcelRequire('2rynm'));

});

parcelRegister("fh4WQ", function(module, exports) {

var $9d5GH = parcelRequire("9d5GH");


var $d6TaN = parcelRequire("d6TaN");

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $b1ec481d92afa1cf$var$baseForOwn(object, iteratee) {
    return object && $9d5GH(object, iteratee, $d6TaN);
}
module.exports = $b1ec481d92afa1cf$var$baseForOwn;

});

parcelRegister("iawSg", function(module, exports) {

var $fh4WQ = parcelRequire("fh4WQ");


var $fKRi0 = parcelRequire("fKRi0");

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $d3a2a94fdae59b54$var$baseEach = $fKRi0($fh4WQ);
module.exports = $d3a2a94fdae59b54$var$baseEach;

});

parcelRegister("fKRi0", function(module, exports) {

var $bRRFB = parcelRequire("bRRFB");

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $b7847d143ef17a3d$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$bRRFB(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = $b7847d143ef17a3d$var$createBaseEach;

});

parcelRegister("hQNhB", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $cfed858cac4ecf38$var$noop() {
// No operation performed.
}
module.exports = $cfed858cac4ecf38$var$noop;

});

parcelRegister("ghltV", function(module, exports) {

var $jcOUW = parcelRequire("jcOUW");


var $7LQYo = parcelRequire("7LQYo");


var $lkNSx = parcelRequire("lkNSx");


var $bcPN2 = parcelRequire("bcPN2");


var $eSSFf = parcelRequire("eSSFf");


var $fTWVK = parcelRequire("fTWVK");

/** Used as the size to enable large array optimizations. */ var $bd9ee5aa9be27a90$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $bd9ee5aa9be27a90$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $7LQYo, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $lkNSx;
    } else if (length >= $bd9ee5aa9be27a90$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $eSSFf(array);
        if (set) return $fTWVK(set);
        isCommon = false;
        includes = $bcPN2;
        seen = new $jcOUW;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $bd9ee5aa9be27a90$var$baseUniq;

});

parcelRegister("7LQYo", function(module, exports) {

var $gbGQI = parcelRequire("gbGQI");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $5a8603892d8b8e7a$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $gbGQI(array, value, 0) > -1;
}
module.exports = $5a8603892d8b8e7a$var$arrayIncludes;

});

parcelRegister("gbGQI", function(module, exports) {

var $kQ62s = parcelRequire("kQ62s");


var $4iBhD = parcelRequire("4iBhD");


var $9vdTF = parcelRequire("9vdTF");

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $bc8ee968e98dba2a$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $9vdTF(array, value, fromIndex) : $kQ62s(array, $4iBhD, fromIndex);
}
module.exports = $bc8ee968e98dba2a$var$baseIndexOf;

});

parcelRegister("kQ62s", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $f2bd591dc7dccf33$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $f2bd591dc7dccf33$var$baseFindIndex;

});

parcelRegister("4iBhD", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $3215c39807e7891a$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $3215c39807e7891a$var$baseIsNaN;

});

parcelRegister("9vdTF", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $6eb1c9efc79a544d$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $6eb1c9efc79a544d$var$strictIndexOf;

});

parcelRegister("lkNSx", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $f882281822db2c99$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $f882281822db2c99$var$arrayIncludesWith;

});

parcelRegister("eSSFf", function(module, exports) {

var $l57m2 = parcelRequire("l57m2");


var $hQNhB = parcelRequire("hQNhB");


var $fTWVK = parcelRequire("fTWVK");

/** Used as references for various `Number` constants. */ var $ad608304180e5c8a$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $ad608304180e5c8a$var$createSet = !($l57m2 && 1 / $fTWVK(new $l57m2([
    ,
    -0
]))[1] == $ad608304180e5c8a$var$INFINITY) ? $hQNhB : function(values) {
    return new $l57m2(values);
};
module.exports = $ad608304180e5c8a$var$createSet;

});

parcelRegister("a1A9A", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $584545d3b04636eb$export$7ddbcd2882651055 = (0, $eSUdr.default)`query OperationsQuery{siteOperations{userProfile application}}`;
module.exports["OperationsQuery"] = $584545d3b04636eb$export$7ddbcd2882651055;

});

parcelRegister("w033M", function(module, exports) {
const $ea2c8f52a33264f1$export$4782acb2cb5b7c11 = (queryData)=>Boolean(queryData?.isSiteAdmin);
module.exports["getIsSiteAdminFromQuery"] = $ea2c8f52a33264f1$export$4782acb2cb5b7c11;

});

parcelRegister("fWkVZ", function(module, exports) {
const $b7fc105cb96f63fd$export$7ed4faccc7e85b7f = (queryData)=>Boolean(queryData?.user?.confluence?.operations?.some((o)=>o?.operation === 'administer' && o?.targetType === 'application'));
module.exports["getIsProductAdminFromQuery"] = $b7fc105cb96f63fd$export$7ed4faccc7e85b7f;

});

parcelRegister("3GH4X", function(module, exports) {

var $3PAnx = parcelRequire("3PAnx");


var $77wHb = parcelRequire("77wHb");

/** Used for built-in method references. */ var $2af6b5f2fc42996a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2af6b5f2fc42996a$var$hasOwnProperty = $2af6b5f2fc42996a$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the number of times the key was returned by `iteratee`. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.countBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': 1, '6': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.countBy(['one', 'two', 'three'], 'length');
 * // => { '3': 2, '5': 1 }
 */ var $2af6b5f2fc42996a$var$countBy = $77wHb(function(result, value, key) {
    if ($2af6b5f2fc42996a$var$hasOwnProperty.call(result, key)) ++result[key];
    else $3PAnx(result, key, 1);
});
module.exports = $2af6b5f2fc42996a$var$countBy;

});

parcelRegister("77wHb", function(module, exports) {

var $gETEr = parcelRequire("gETEr");


var $bSxMj = parcelRequire("bSxMj");


var $hWvFC = parcelRequire("hWvFC");


var $fZxmY = parcelRequire("fZxmY");

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */ function $52f28c800c0dec0e$var$createAggregator(setter, initializer) {
    return function(collection, iteratee) {
        var func = $fZxmY(collection) ? $gETEr : $bSxMj, accumulator = initializer ? initializer() : {};
        return func(collection, setter, $hWvFC(iteratee, 2), accumulator);
    };
}
module.exports = $52f28c800c0dec0e$var$createAggregator;

});

parcelRegister("gETEr", function(module, exports) {
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $c20b8cf123ccbac3$var$arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
}
module.exports = $c20b8cf123ccbac3$var$arrayAggregator;

});

parcelRegister("bSxMj", function(module, exports) {

var $iawSg = parcelRequire("iawSg");

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $8a5ef07d195ea024$var$baseAggregator(collection, setter, iteratee, accumulator) {
    $iawSg(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
    });
    return accumulator;
}
module.exports = $8a5ef07d195ea024$var$baseAggregator;

});

parcelRegister("1wScy", function(module, exports) {

var $3PAnx = parcelRequire("3PAnx");


var $77wHb = parcelRequire("77wHb");

/** Used for built-in method references. */ var $11d2d2e303d6c19d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $11d2d2e303d6c19d$var$hasOwnProperty = $11d2d2e303d6c19d$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */ var $11d2d2e303d6c19d$var$groupBy = $77wHb(function(result, value, key) {
    if ($11d2d2e303d6c19d$var$hasOwnProperty.call(result, key)) result[key].push(value);
    else $3PAnx(result, key, [
        value
    ]);
});
module.exports = $11d2d2e303d6c19d$var$groupBy;

});

parcelRegister("6a9Hv", function(module, exports) {

var $hWvFC = parcelRequire("hWvFC");


var $ghltV = parcelRequire("ghltV");

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $47cb339bef10f9e0$var$uniqBy(array, iteratee) {
    return array && array.length ? $ghltV(array, $hWvFC(iteratee, 2)) : [];
}
module.exports = $47cb339bef10f9e0$var$uniqBy;

});

parcelRegister("foQ4a", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $19052bf55936e796$export$e581bd1f88227e0a = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isExternalCollaborator: accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS
    };
};
module.exports["useIsExternalCollaborator"] = $19052bf55936e796$export$e581bd1f88227e0a;

});

parcelRegister("bFDX4", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $8182af0d2f396edd$export$5df30e64c619846d = (error)=>(0, $aMcHK.isStatusCodeError)(error, '429');
module.exports["isTooManyRequestsError"] = $8182af0d2f396edd$export$5df30e64c619846d;

});

parcelRegister("1OQlm", function(module, exports) {
const $b3217fa901c7995d$export$bf98aa5bf4a9468c = (extension)=>extension?.dataClassificationPolicyDecision?.status === 'BLOCKED';
module.exports["isBlockedByAppAccessRule"] = $b3217fa901c7995d$export$bf98aa5bf4a9468c;

});

parcelRegister("aF5bm", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");

const $3217b30f8fcccab4$export$c922e8420e7a46c9 = ({ cloudId: cloudId, activationId: activationId })=>{
    return `ari:cloud:confluence:${cloudId}:workspace/${activationId}`;
};
const $3217b30f8fcccab4$export$3c417c5065f4ac35 = ()=>{
    const { cloudId: cloudId, activationId: activationId } = (0, $bQm3c.useSessionData)();
    return $3217b30f8fcccab4$export$c922e8420e7a46c9({
        cloudId: cloudId,
        activationId: activationId
    });
};
module.exports["getWorkspaceARI"] = $3217b30f8fcccab4$export$c922e8420e7a46c9;
module.exports["useWorkspaceARI"] = $3217b30f8fcccab4$export$3c417c5065f4ac35;

});


//# sourceMappingURL=SpaceNavigation.dc6eb035.js.map
